import { Box, Menu, MenuItem, Typography, IconButton, Tooltip } from '@mui/material';
import { FC, useState } from 'react';
import i18n from 'i18next';
import { useLanguageSwitcher } from '../../hooks/useLanguageSwitcher';
import TranslateIcon from '@mui/icons-material/Translate';
import { useTranslation } from 'react-i18next';

const languages: { code: string; name: string }[] = [
  { code: 'en', name: 'English' },
];

interface LanguageSelectorProps {
  variant?: 'icon' | 'full';
}

const LanguageSelector: FC<LanguageSelectorProps> = ({ variant = 'full' }): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { t } = useTranslation();

  const close = () => setOpen(false);
  const { switchLanguage } = useLanguageSwitcher(i18n, close);

  const onChangeLanguage = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const onSelect = (languageCode: string) => {
    switchLanguage(languageCode);
  };

  if (variant === 'icon') {
    return (
      <>
        <Tooltip title={t('common.changeLanguage')}>
          <IconButton onClick={onChangeLanguage} sx={{ color: 'inherit' }}>
            <TranslateIcon />
          </IconButton>
        </Tooltip>
        <Menu open={open} anchorEl={anchorEl} onClose={close}>
          {languages.map((language) => (
            <MenuItem key={language.code} onClick={() => onSelect(language.code)}>
              <Typography variant="textXS">{language.name}</Typography>
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }

  return (
    <>
      <Box
        onClick={onChangeLanguage}
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        flexGrow={1}
        sx={{
          cursor: 'pointer',
          '&:hover': {
            opacity: 0.8,
          },
        }}
      >
        <TranslateIcon sx={{ fontSize: 18, color: 'inherit' }} />
        <Typography
          sx={{
            fontWeight: 500,
            flexGrow: 1,
            ml: '10px',
            fontSize: 14,
          }}
        >
          {t('common.changeLanguage')}
        </Typography>
      </Box>
      <Menu open={open} anchorEl={anchorEl} onClose={close}>
        {languages.map((language) => (
          <MenuItem key={language.code} onClick={() => onSelect(language.code)}>
            <Typography variant="textMD">{language.name}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
